import { BaseObject } from "../core/BaseObject";
import { ProdCalendarDay } from "./ProdCalendarDay";

export class ProdCalendar extends BaseObject {
    prodCalendarId: number;
    year: number;
    days: ProdCalendarDay[] = [];
}